// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangesTemplate_wrapper__k8jmp","section":"ChangesTemplate_section__c+Q9a","emptyData":"ChangesTemplate_emptyData__9hZwC"};